import { EventEmitter, inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ObjectUtils } from '@rp/utils';

@Injectable({ providedIn: 'root' })
export class HeaderStateService {
  title = signal<string>(null);
  showBack = signal<boolean>(false);
  backRoute = signal<boolean>(false);

  backClick = new EventEmitter<void>();

  private _route = inject(ActivatedRoute);

  reset(): void {
    this.showBack.set(false);
    this.backRoute.set(false);

    this.setDataFromRoute();
  }

  setDataFromRoute(): void {
    let child = this._route.firstChild;

    while (child?.firstChild) {
      child = child.firstChild;
    }

    const isDataEmpty = ObjectUtils.isEmptyObject(child.snapshot.data);

    if (!isDataEmpty) {
      const { title, showBack, backRoute } = child.snapshot.data;

      if (title) {
        this.title.set(title);
      }

      this.showBack.set(showBack);
      this.backRoute.set(backRoute);
    }
  }
}
